import { render, staticRenderFns } from "./AdditionalChildSection.vue?vue&type=template&id=266ae26a&scoped=true"
import script from "./AdditionalChildSection.vue?vue&type=script&lang=js"
export * from "./AdditionalChildSection.vue?vue&type=script&lang=js"
import style0 from "./AdditionalChildSection.vue?vue&type=style&index=0&id=266ae26a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ae26a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266ae26a')) {
      api.createRecord('266ae26a', component.options)
    } else {
      api.reload('266ae26a', component.options)
    }
    module.hot.accept("./AdditionalChildSection.vue?vue&type=template&id=266ae26a&scoped=true", function () {
      api.rerender('266ae26a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/attendance/components/AdditionalChildSection.vue"
export default component.exports